export const BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY = "ub_bonus_program_checkout_intent"
export const BONUS_PROGRAM_CHECKOUT_INTENT_CONSUMED_SESSION_STORAGE_KEY = "ub_bonus_program_checkout_intent_consumed"
